import { toast } from "react-toastify";

export const ACCESS_DENIED_MESSAGE =
  "Access denied. Please contact the TriloDocs Team.";

// The axios interceptors live outside the React tree, so they need a container
// they can always reach. Pages mount their own unnamed <ToastContainer /> for
// their own toasts; react-toastify only delivers a toast carrying an explicit
// containerId to the container registered under that id, so this one stays
// isolated from them.
export const GLOBAL_TOAST_CONTAINER_ID = "global-toast";

// A single page often fires several requests at once. Reusing one toastId means
// react-toastify drops the duplicates while the first is still on screen,
// so a batch of 403s surfaces as one message rather than a stack of them.
const ACCESS_DENIED_TOAST_ID = "access-denied";

export const showAccessDeniedToast = (message = ACCESS_DENIED_MESSAGE) =>
  toast.error(message, {
    toastId: ACCESS_DENIED_TOAST_ID,
    containerId: GLOBAL_TOAST_CONTAINER_ID,
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  });

// Route of the page a login refusal lands on. Kept next to the message so the
// two ways a 403 surfaces — toast and full page — stay in one place.
export const ACCESS_DENIED_PATH = "/access-denied";

// POST /login is the only 403 that takes over the whole page, so the axios
// interceptor has to recognise it from the failed request alone.
export const isLoginForbidden = error =>
  error?.response?.status === 403 &&
  error?.config?.method?.toLowerCase() === "post" &&
  /\/login\/?$/.test(error?.config?.url ?? "");
